import { updateURLs } from '../url';

function initCTAButtons( container ) {
    if ( !container ) {
        return;
    }

    var ctaContainer = container.querySelector( 'form' );
    var textarea = container.querySelector( '[name=message]' );

    // page with 'offline' property does not hava a form at all
    if ( textarea ) {
        textarea.addEventListener( 'keyup', function( event ) {
            updateURLs( '.contact-url-updatable', 'text-value', encodeURI( event.target.value ) );
        } );
    }

    var makeOfferWrap = container.querySelector( '[data-ts-cta-price-cont]' );
    var makeOfferInput = makeOfferWrap ? makeOfferWrap.querySelector( 'input' ) : null;

    var makeOfferInputOnKeydown = function( event ) {
        if ( event.keyCode === 13 ) {
            event.preventDefault();
        }
    };

    var makeOfferInputOnKeyup = function( event ) {
        updateURLs( '.contact-url-updatable', 'offer-quantity', event.target.value );
    };

    var showMakeOfferField = function() {
        if ( !makeOfferWrap || !makeOfferInput ) {
            return;
        }

        makeOfferWrap.style.display = '';
        makeOfferInput.focus();

        makeOfferInput.addEventListener( 'keydown', makeOfferInputOnKeydown );
        makeOfferInput.addEventListener( 'keyup', makeOfferInputOnKeyup );
    };

    var hideMakeOfferField = function() {
        if ( !makeOfferWrap || !makeOfferInput ) {
            return;
        }

        makeOfferWrap.style.display = 'none';
        makeOfferInput.value = '';
        makeOfferInput.removeEventListener( 'keydown', makeOfferInputOnKeydown );
        makeOfferInput.removeEventListener( 'keyup', makeOfferInputOnKeyup );
    };

    var showQuestionField = function( value ) {
        textarea.style.display = 'block';
        textarea.focus();
        textarea.setSelectionRange( textarea.value.length, textarea.value.length );

        const showTextAreaBtn = container.querySelector( '[data-ts-cta-ask]' );

        if ( showTextAreaBtn ) {
            showTextAreaBtn.remove();
        }

        updateURLs( '.contact-url-updatable', 'text', value );
    };

    var handleClickCTABtns = function handleClickCTABtns() {
        var btns = container.querySelectorAll( '[data-ts-cta-btn]' );

        btns.forEach( function( el ) {
            el.addEventListener( 'click', function( e ) {
                var action = e.target.dataset.tsCtaAction;

                if ( action === 'ask-question' ) {
                    showQuestionField( true );
                }

                var checkbox = ctaContainer.querySelector( '[data-ts-cta-action=' + action + ']' );

                if ( action === 'make-offer' ) {
                    if ( checkbox && checkbox.checked ) {
                        if ( makeOfferWrap ) {
                            makeOfferWrap.style.display = '';
                        }
                        var priceOfferElement = container.querySelector( '[data-ts-cta-price-cont]' );
                        if ( priceOfferElement ) {
                            priceOfferElement.classList.remove( 'd-none' );
                        }
                    }
                    if ( makeOfferInput ) {
                        makeOfferInput.focus();
                    }
                }

                if ( checkbox && !checkbox.checked ) {
                    checkbox.dispatchEvent( new Event( 'click', { bubbles: true } ) );
                }
            } );
        } );
    };

    var handleClickSuggestOffer = function handleClickSuggestOffer() {
        var btns = container.querySelectorAll( '[data-ts-cta-btn-custom]' );
        btns.forEach( function( el ) {
            el.addEventListener( 'click', function( e ) {
                var ele = e.target;
                var eleAction = ele.dataset.tsCtaAction; // is checkbox and checking (activating)

                if ( ele.localName === 'a' || ele.checked ) {
                    container.querySelector( '[data-ts-cta-action=' + eleAction + ']' ).checked = true;
                    showMakeOfferField();
                    updateURLs( '.contact-url-updatable', eleAction, true );
                } else {
                    hideMakeOfferField();
                    container.querySelector( '[data-ts-cta-action=' + eleAction + ']' ).checked = false;
                    updateURLs( '.contact-url-updatable', eleAction, false );
                }
            } );
        } );
    };

    handleClickCTABtns();
    handleClickSuggestOffer();

    if ( makeOfferWrap && makeOfferWrap.style.display === '' ) {
        showMakeOfferField();
    }
}

export default initCTAButtons;
